import emptySliceApi from '../../shared/store/emptyApiSlice';
import {
  HubAccountInviteSelectDto,
  HubAccountSelectResponseDto,
} from './models';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getHubAccountList: builder.query<HubAccountSelectResponseDto[], void>({
      query: () => 'v4/users/accounts',
      transformResponse: (
        response: HubAccountSelectResponseDto[],
      ): HubAccountSelectResponseDto[] => [
        ...new Map(response.map((v) => [v.account.id, v])).values(), // Remove duplicates with same account id
      ],
    }),
    getHubInvitationList: builder.query<HubAccountInviteSelectDto[], void>({
      query: () => 'v4/users/invites',
    }),
  }),
});

export const { useGetHubAccountListQuery, useGetHubInvitationListQuery } =
  apiSlice;
